<template>
<div>
    <sav-template :back-button="false">
        <h1 class="text-4xl font-light">{{$t('parametres.mon_compte')}}</h1>
        <h6 class="mt-1 mb-8 font-extralight">{{$t('parametres.gerer_toutes_les_informations_liees_a_votre_compte')}}</h6>
        <div v-if="sectionSelected" class="md:flex items-center overflow-x-auto border-b border-gray-100 md:border-gray-300">
            <div
            v-for="(section, sectionIndex) in sections"
            :key="'section-' + sectionIndex"
            :test-id="section.name + '-menu-item'"
            class="flex items-center px-3 py-4 md:py-2 font-light duration-200 border border-b-0 cursor-pointer md:rounded-t-xl"
            :class=" (sectionSelected.name == section.name ? 'bg-gray-200 md:border-gray-300' : 'hover:bg-gray-200 border-gray-100 hover:border-gray-300') + (sectionIndex == 0 ? ' md:mr-1 ' : ' md:mx-1 ')"
            @click="sectionSelected = section">
                <i :class="section.icon" class="mr-2"></i>
                <span class="text-sm">{{section.label}}</span>
            </div>
        </div>
        <component v-if="sectionSelected" :is="sectionSelected.component" class="mt-3" :user="user ? user : null" />
    </sav-template>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import eventHub from '@/eventHub'
export default {
    data() {
        return {
            user: null,
            sectionSelected: null,
            sections: [
                {
                    name: 'account',
                    label: this.$t('parametres.mon_compte'),
                    icon: 'fas fa-user',
                    component: require(`./settings/AccountSettingsSection`).default,
                },
                {
                    name: 'personnal',
                    label: this.$t('parametres.informations_personnelles'),
                    icon: 'fas fa-lock',
                    component: require(`./settings/PersonnalSettingsSection`).default,
                },
                {
                    name: 'address',
                    label: this.$t('parametres.mes_adresses'),
                    icon: 'fas fa-location-dot',
                    component: require(`./settings/AddressSettingsSection`).default,
                }
            ],
        }
    },
    
    methods: {
        async getUser() {
            this.user = await apiService.getUser()
            if (this.user.tel == '0')
                this.user.tel = null
            if (localStorage.getItem('user-session')) {
                const d = new Date();
                let currentTime = d.getTime()
                localStorage.setItem('user-session', JSON.stringify({
                    user: this.user,
                    time: currentTime
                }))
            }
        }
    },

    async mounted() {
        this.sectionSelected = this.sections[0]
        this.getUser()
        eventHub.$on('refresh-user', () => {
            this.getUser()
        })

        // Add translate option
        // if (this.$companyTool.confFile().translates) {
        //     this.sections.push({
        //         name: 'translate',
        //         label: this.$t('parametres.langues'),
        //         icon: 'fas fa-globe',
        //         component: require(`./settings/AccountSettingsLangage`).default,
        //     })
        // }

    }
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/user/Update.vue